var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUpcoming(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99996 6C9.28862 6 10.3333 4.95533 10.3333 3.66667C10.3333 2.378 9.28862 1.33334 7.99996 1.33334C6.71129 1.33334 5.66663 2.378 5.66663 3.66667C5.66663 4.95533 6.71129 6 7.99996 6Z",
    fill: "#1DA687"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.99996 1.83334C6.98744 1.83334 6.16663 2.65415 6.16663 3.66667C6.16663 4.67919 6.98744 5.5 7.99996 5.5C9.01248 5.5 9.83329 4.67919 9.83329 3.66667C9.83329 2.65415 9.01248 1.83334 7.99996 1.83334ZM5.16663 3.66667C5.16663 2.10186 6.43515 0.833336 7.99996 0.833336C9.56477 0.833336 10.8333 2.10186 10.8333 3.66667C10.8333 5.23148 9.56477 6.5 7.99996 6.5C6.43515 6.5 5.16663 5.23148 5.16663 3.66667Z",
    fill: "#1DA687"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.33337 8.83334C4.23882 8.83334 1.83337 11.051 1.83337 13.6667C1.83337 13.9428 1.60952 14.1667 1.33337 14.1667C1.05723 14.1667 0.833374 13.9428 0.833374 13.6667C0.833374 10.3913 3.80052 7.83334 7.33337 7.83334C7.60952 7.83334 7.83337 8.05719 7.83337 8.33334C7.83337 8.60948 7.60952 8.83334 7.33337 8.83334Z",
    fill: "#1DA687"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3334 14.3333C12.9902 14.3333 14.3334 12.9902 14.3334 11.3333C14.3334 9.67648 12.9902 8.33334 11.3334 8.33334C9.67652 8.33334 8.33337 9.67648 8.33337 11.3333C8.33337 12.9902 9.67652 14.3333 11.3334 14.3333Z",
    fill: "#1DA687"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.3334 8.83334C9.95266 8.83334 8.83337 9.95262 8.83337 11.3333C8.83337 12.714 9.95266 13.8333 11.3334 13.8333C12.7141 13.8333 13.8334 12.714 13.8334 11.3333C13.8334 9.95262 12.7141 8.83334 11.3334 8.83334ZM7.83337 11.3333C7.83337 9.40034 9.40038 7.83334 11.3334 7.83334C13.2664 7.83334 14.8334 9.40034 14.8334 11.3333C14.8334 13.2663 13.2664 14.8333 11.3334 14.8333C9.40038 14.8333 7.83337 13.2663 7.83337 11.3333Z",
    fill: "#1DA687"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 9.83334C11.2761 9.83334 11.5 10.0572 11.5 10.3333V11.1667H12.3333C12.6095 11.1667 12.8333 11.3905 12.8333 11.6667C12.8333 11.9428 12.6095 12.1667 12.3333 12.1667H11C10.7239 12.1667 10.5 11.9428 10.5 11.6667V10.3333C10.5 10.0572 10.7239 9.83334 11 9.83334Z",
    fill: "#FFFBFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpcoming);
export default __webpack_public_path__ + "static/media/upcoming.4bedda4e66fac732fb46512349bef208.svg";
export { ForwardRef as ReactComponent };